import React from 'react';
//import styles from './Newsletter.css';

function Newsletter() {
  return (
<div className="mainContent">
<h1>Christian Screenwriters' Newsletter </h1>
            <p> Claire has been publishing the Christian Screenwriters' Newsletter since 2005. The newsletter has a subscriber base of over 550 screenwriters, producers and others interested in faith-based filmmaking. It is filled with interviews with noted industry professionals, tips, contests, announcements, etc. If you would like to subscribe, please email Claire at <a href="mailto:info@ambassadorcommunications.biz">info@ambassadorcommunications.biz</a>.</p>
              
          <p>You can also join us on Facebook by subscribing at the following link: <a href="https://www.facebook.com/christianscreenwritersnewsletter/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/christianscreenwritersnewsletter/</a></p>   
</div>
  )
  }

export default Newsletter;
